// Remembers how far each page was scrolled before leaving it, for the router to restore on back and forward
export default defineNuxtPlugin(() => {
  useRouter().beforeEach((_to, from) => {
    const container = getScrollContainer()

    if (container) {
      scrollPositions.set(from.fullPath, container.scrollTop)
    }
  })
})
